import { DeviceManager } from '@yandex-360/telemost-sdk/device-manager';

import { goloomSdk } from '../goloom-sdk/instance';
import { createGoloomMediaBackend } from './adapters/goloom';
import { createTelemostDeviceManagerHost } from './create-telemost-device-manager-host';

export const deviceManager = new DeviceManager({
    ...createGoloomMediaBackend(goloomSdk),
    host: createTelemostDeviceManagerHost(),
});
